var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#333F48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.31322C9.48863 3.31322 9.07407 3.72777 9.07407 4.23914L9.07407 15.7624C9.07407 16.2737 9.48863 16.6883 10 16.6883C10.5114 16.6883 10.9259 16.2737 10.9259 15.7624L10.9259 4.23914C10.9259 3.72777 10.5114 3.31322 10 3.31322Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31224 10.001C3.31224 9.4896 3.72679 9.07505 4.23817 9.07505L15.7614 9.07505C16.2728 9.07505 16.6873 9.4896 16.6873 10.001C16.6873 10.5124 16.2728 10.9269 15.7614 10.9269L4.23817 10.9269C3.72679 10.9269 3.31224 10.5124 3.31224 10.001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.00008015f13791d8790dfe13c6938bd8.svg";
export { ForwardRef as ReactComponent };